import { useEffect, useState } from 'react';
import GenericDataTable from './GenericDataTable';
import ShipmentUpdateHistoryTableRowFormatter from './ShipmentUpdateHistoryTableRowFormatter';
import { ShipmentUpdateModel } from '../apiModels/shipmentUpdateModel';
import { toast } from 'react-toastify';
import { logError } from '../utilities';
import { getShipmentUpdates } from '../api/shipmentUpdateApi';
import { getAllProofOfDeliveryForShipment } from '../api/proofOfDeliveryApi';
import { ProofOfDeliveryModel } from '../apiModels/proofOfDeliveryModel';

export default function ProofOfDeliveryRequestTable(props: {
    shipmentTrackingNumber: string
}) {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [proofOfDeliveryRequests, setProofOfDeliveryRequests] = useState<ProofOfDeliveryModel[]>([]);

    const loadProofOfDeliveryRequests = async (trackingNumber: string) => {
        setIsTableLoading(true);

        try {
            let updates = await getAllProofOfDeliveryForShipment(trackingNumber);
            setProofOfDeliveryRequests(updates);
            setIsTableLoading(false);
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);
            setIsTableLoading(false);
        }
    };

    useEffect(() => {
        loadProofOfDeliveryRequests(props.shipmentTrackingNumber);
    }, [props.shipmentTrackingNumber]);

    return (
        <GenericDataTable data={proofOfDeliveryRequests}
            dataFormatter={(data) => <>{data.map((d) => <tr key={d.email}><td>{d.email}</td></tr>)}</>}
            noDataMessage='There are no proof of delivery requests for this shipment.'
            columnCount={1}
            isLoading={isTableLoading}>
            <tr>
                <td>Email</td>
            </tr>
        </GenericDataTable>
    );
}